import React, { Suspense, useEffect, useState } from "react";
import { ConfigProvider, Layout, Spin } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import LeftSlider from "./left-slider/left-slider";
import notification from "../service/notification";
import AppHeader from "../common/app-header/app-header";
import { useWindowDimensions } from "../common/windowDimensions";
import { ErrorBoundary } from "../common/error-boundary/error-boundary";
import { Content } from "antd/es/layout/layout";
import * as accountService from "./../service/accountService";
import { encryptData, SECRET_KEY } from "../util/encryption";
import { LocalStorageKeys } from "../constants/localStorageKeys";
import * as localStorageService from "./../service/localStorageService";
import { useStore } from "./../store/store";
import './auth-layout.scss'
import { CommonConstants } from "../constants/commonConstants";

const GuestLayout = () => {
  const { width } = useWindowDimensions();
  const onLeftSiderCollapse = (isMenuOpen) => {
    setIsLeftMenuOpen(isMenuOpen);
  };
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(true);
  const [isWaitLanguage, setIsWaitLanguage] = useState(false);
  const [direction, setDirection] = useState("ltr");
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const { user } = useStore();
  const navigate = useNavigate();
  const isGuest = localStorageService.getValue("guestMode") === "true";

  useEffect(() => {
    if (isGuest) {
      setIsUserLoaded(true);
    }
  }, []);

  return (
    <div>
      <Layout className="authLayout-wrapper">
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Silka Regular",
              colorPrimary: "#FF5D00",
            },
          }}
          direction={
            localStorageService.getValue(LocalStorageKeys.Lang) == CommonConstants.ArabicLanguageCode
              ? "rtl"
              : "ltr"
          }
        >
          <LeftSlider onCollapse={onLeftSiderCollapse} />

          <Layout style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <ErrorBoundary>
              <Content className="content-body-wrapper">
                <AppHeader />
                <Suspense
                  fallback={
                    <Spin
                      style={{ marginLeft: "50%", marginTop: "10%" }}
                    ></Spin>
                  }
                >
                  <Outlet />
                </Suspense>
              </Content>
            </ErrorBoundary>
          </Layout>

        </ConfigProvider>
      </Layout>
    </div>
  );
};

export default GuestLayout;



